export enum COOKIE_KEYS {
  MY_GRIMME_CORE_MAINTENANCE_POPUP = 'MY-GRIMME-CORE-MAINTENANCE-POPUP',
  CONTACT_ASSISTANT_COOKIE = 'NEXT_WEBSITE_CONTACT_ASSISTANT',
}
